/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

import type { ContentValue } from '@glint/template';
import type { TText } from 'volta/utils/text-utils';

export type TTooltipSide = 'auto' | 'left' | 'right' | 'bottom' | 'top';

export interface TooltipContent {
  text?: ContentValue;
  subtext?: ContentValue;
}

export interface BvTooltipSignature {
  Args: {
    class?: string;
    content?: TooltipContent[];
    event?: 'hover' | 'click' | 'none';
    isShown?: boolean;
    popperContainer?: string;
    popperOptions?: string;
    side?: TTooltipSide;
    subtext?: ContentValue;
    targetId?: string;
    text?: TText;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const BvTooltipComponent = templateOnlyComponent<BvTooltipSignature>('BvTooltip');

export default BvTooltipComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvTooltip: typeof BvTooltipComponent;
    'bv-tooltip': typeof BvTooltipComponent;
  }
}
